export const capitalizeWords = (str: string) => {
    if (typeof str !== "string" || !str.trim()) return "";

    return (
        str
            // 1. Replace underscores, dashes, and slashes with spaces
            .replace(/[-_/]+/g, " ")
            // 2. Insert a space before capital letters (camelCase → camel Case)
            .replace(/([a-z])([A-Z])/g, "$1 $2")
            // 3. Collapse multiple spaces into one
            .replace(/\s+/g, " ")
            .trim()
            // 4. Capitalize each word
            .split(" ")
            .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
            .join(" ")
    );
};

export const toSentenceCase = (str: string) => {
    if (typeof str !== "string" || !str.trim()) return "";
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};